import numeral from 'numeral'

export const humanFileSize = bytes => {
  return numeral(bytes).format('0.0 b')
}
